import React, { lazy } from 'react';

const LazyRideBooking = lazy(() => import('./RideBooking'));

const RideBooking = (props) => <LazyRideBooking {...props} />;

export default RideBooking;
